import { useMemo } from 'react';
import { endOfDay } from 'date-fns';
import { cloneDeep } from 'lodash';
import { getArmenianLocalDate } from '../helpers/dates';

// @TODO rename function name
const useOncoCareContractRange = () => useMemo(() => {
  const start = endOfDay(new Date(getArmenianLocalDate()));
  start.setDate(start.getDate() + 1); // Start is tomorrow

  const end = cloneDeep(start);
  end.setFullYear(end.getFullYear() + 1);

  end.setDate(end.getDate() - 1); // Subtract one day from the end date

  const timeDifference = end.getTime() - start.getTime();
  const days = Math.ceil(timeDifference / (1000 * 3600 * 24));

  return {
    start,
    end,
    days,
  };
}, []);

export default useOncoCareContractRange;
